import { atom } from 'recoil';

export const intervenePresenceAtom = atom({
  key: 'intervenePresenceAtom_v2',
  default: {},
});

export const interveneSocketConnectionAtom = atom({
  key: 'interveneSocketConnectionAtom_v2',
  default: {
    chat: 'Disconnected',
    status: 'Disconnected',
    notificationsBridge: 'Disconnected',
  },
});
